export default "__VITE_ASSET__DlLTt3XW__"